import { SERVICE_FRAGMENT } from '../@shared-fragments/serviceFragment';
import { mapService } from '../@shared-mappers/mapService';

import { createQueryHook } from '~/shared/providers/api';

export const useLoadBoardServicesQuery = createQueryHook(
  'transportation.loadBoard',
  (params: { start?: string; end?: string }) => ({
    loadBoard: {
      __args: {
        filter: {
          scheduledStartAfter: params.start,
          scheduledEndBefore: params.end,
        },
      },
      services: { ...SERVICE_FRAGMENT },
    },
  }),
  {
    select: (data) => (data?.loadBoard?.services ?? []).map(mapService),
  },
);
